import { LitElement , css, html } from '~/lib/bn-lit-element';
import { sharedStyles } from '../../styles/shared-styles';
import { bannerStyles } from '../../styles/banner-styles';
import { LitSirenEntityMixin } from '../../utility/lit-siren-entity-mixin';
import './import-mapping-target';

class ImportWarnings extends LitSirenEntityMixin(LitElement) {
  static get styles() {
    return [sharedStyles, bannerStyles, css`
      .header {
        margin-bottom: 0.2em;
      }
      .warning-lines {
        overflow: auto;
        max-height: 20em;
      }
    `];
  }

  render() {
    const { state, warnings } = this.entity.properties;
    if (!warnings || !['valid', 'completed'].includes(state)) {
      return html``;
    }

    return html`
      <div>
        <div class="banner banner--warning">
          <div class="header">${state === 'valid' ? 'Validation Warnings' : 'Import Warnings'}</div>
          <div class="warning-lines">
            ${warnings.map((warning) => html`<div><code>${warning}</code></div>`)}
          </div>
        </div>
      </div>
    `;
  }
}

window.customElements.define('import-warnings', ImportWarnings);
